import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const FloatingCall = () => (
  <motion.a
    href="tel:1800724336"
    data-testid="floating-call-btn"
    aria-label="Call ColdFast Couriers now on 1800 724 336"
    initial={{ opacity: 0, y: 24, scale: 0.9 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-3 bg-blaze text-white font-mono text-xs uppercase tracking-[0.15em] pl-5 pr-6 py-4 shadow-[0_8px_30px_rgba(255,59,48,0.4)] hover:bg-frost hover:text-abyss hover:shadow-[0_8px_30px_rgba(0,240,255,0.4)] transition-colors duration-300 active:scale-95"
  >
    <span className="relative flex items-center justify-center w-5 h-5">
      <span className="animate-ping absolute inline-flex h-4 w-4 rounded-full bg-current opacity-40" aria-hidden="true" />
      <Phone className="relative w-4 h-4" strokeWidth={1.5} />
    </span>
    <span className="hidden sm:inline">Call now — 1800 724 336</span>
    <span className="sm:hidden">Call now</span>
  </motion.a>
);

export default FloatingCall;
